import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-65d5a9c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main" }
const _hoisted_2 = { class: "input-wrap" }
const _hoisted_3 = { class: "btn-wrap" }

import { ref, onActivated } from 'vue'
import AppHeader from '@/components/Header.vue'
import { Button, Field } from 'vant'


export default /*#__PURE__*/_defineComponent({
  __name: 'input-sn',
  emits: ['submitSn', 'protoc'],
  setup(__props, { emit: emits }) {

const sn = ref('')

 

const onSubmit = () => {
  emits('submitSn', sn.value)
}

 onActivated(()=>{
  sn.value = ''
})
function onProtoc(){
  console.log('onProtoc')
  emits('protoc')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader, { title: "输入包装序列号" }),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(Field), {
          modelValue: sn.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((sn).value = $event)),
          clearable: "",
          placeholder: "输入包装序列号"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(Button), {
          disabled: sn.value.length === 0,
          block: "",
          round: "",
          type: "success",
          class: "submit-btn",
          onClick: onSubmit
        }, {
          default: _withCtx(() => [
            _createTextVNode("确认")
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      _createElementVNode("div", {
        class: "tip",
        onClick: onProtoc
      }, "找不到序列号？")
    ])
  ], 64))
}
}

})